import * as Icons from '@ant-design/icons';
import {
  DownOutlined,
  LeftOutlined,
  RightOutlined,
  SettingOutlined,
  UserOutlined
} from '@ant-design/icons';
import { Button, Col, Dropdown, Menu, notification, Row, Spin, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom'; // Import useHistory from react-router-dom
import './MainLayout.css';

import useNotification from 'antd/es/notification/useNotification';
import { useDispatch } from 'react-redux';
import { featuresEnum, SelfUserClassificationEnum } from '../../shared/constants/constants';
import { languageMap } from '../../shared/languages/LanguageSelector';
import { useFeatures } from '../../store/context/feature-context';
import { useLanguage } from '../../store/context/language-context';
import { usePermissions } from '../../store/context/permission-context';
import { useTenant } from '../../store/context/tenant-context';
import { useTheme } from "../../store/context/theme-context";
import { logoutUser } from '../../store/redux/actions/userActions';
import { postAuthenticatedRequest } from '../../utils/api/requests/request';
import { navigateToAuth } from '../../utils/helper/redirect';
import { getSessionData } from '../../utils/interceptors/localStorageService';



const { SubMenu } = Menu;

const MainLayout = ({
  collapsed,
  setCollapsed,
  type }) => {
  const [openKeys, setOpenKeys] = useState([]);
  const [selectedMenuGroup, setSelectedMenuGroup] = useState(null); // Default selected menu group
  const [menuData, setMenuData] = useState([]);
  const [isHovered, setIsHovered] = useState(false); // New state to track mouse hover
  const [selectedPath, setSelectedPath] = useState('');
  const { triggerNotification } = useNotification();
  const { theme, toggleTheme } = useTheme();
  const tenant = useTenant();
  const dispatch = useDispatch();
  const location = useLocation();
  const { findFeature } = useFeatures();
  const [isFetchingMenuCommandChains, setIsFetchingMenuCommandChains] = useState(true);
  const { findPermission } = usePermissions();
  const [menuList, setMenuList] = useState(null);
  // console.log("permission from context-sidebar", permissions);
  const { language: languageCode, showModal } = useLanguage();
  const [sessionData, setSessionData] = useState(null);
  const [initials, setInitials] = useState("");
  const languageName = languageMap[languageCode];
  console.log('selectedMenuGroup', selectedMenuGroup);

  const ProfileDropdown = () => {
    const profileMenuItems = [
      {
        key: "profile",
        icon: <UserOutlined />,
        title: "My Profile",
      },
      {
        key: "settings",
        icon: <SettingOutlined />,
        title: "Settings",
      },
      // {
      //   key: "divider",
      //   type: "divider",
      // },
      // {
      //   key: "logout",
      //   icon: <LogoutOutlined />,
      //   title: "Logout",
      //   onClick: handleSignOut,
      // },
    ];

    const handleMenuClick = ({ key }) => {
      navigate(`/${key}`);
      switch (key) {
        case "profile":
          navigate("/settings/profile");
          break;
        case "settings":
          navigate("/settings");
          break;

        default:
          return;
      }
    };
    return (
      <Dropdown
        menu={{
          items: profileMenuItems,
          onClick: handleMenuClick,
          selectable: false,
        }}
        trigger={["click"]}
        placement="bottomRight"
        overlayStyle={{ marginTop: "15px" }}
      >
        <DownOutlined
          style={{ color: tenant.theme.colorPrimary }}
          className="cursor-pointer pointer-events-auto"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      </Dropdown>
    );
  };

  useEffect(() => {
    const storedSessionData = getSessionData();
    if (storedSessionData) {
      setSessionData(storedSessionData);
      const firstNameInitial = (storedSessionData?.firstName ?? "")
        .charAt(0)
        .toUpperCase();
      const lastNameInitial = (storedSessionData?.lastName ?? "")
        .charAt(0)
        .toUpperCase();
      setInitials(`${firstNameInitial}${lastNameInitial}`);
    }
  }, []);

  useEffect(() => {
    fetchSchemas();
  }, [])


  const fetchSchemas = async () => {
    try {
      setIsFetchingMenuCommandChains(true);
      const data = {

        configName: "AdminPortalMenuConfiguration",
        path: "application",
      };
      const response = await postAuthenticatedRequest(
        "GetConfigQuery",
        data
      );

      const result = response?.outData;

      if (result?.isSuccessful) {

        setMenuList(result?.data);
        if (result?.data?.modules.length > 0)
          setSelectedMenuGroup(result?.data?.modules[0].code);

      } else {
        triggerNotification({
          type: "error",
          message: "Error",
          description: result?.message,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);

      triggerNotification({
        type: "error",
        message: "Error",
        description: error,
      });
    } finally {
      setIsFetchingMenuCommandChains(false);
    }
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const { t, i18n } = useTranslation();
  // const menuData = SideMenuData(t, selectedMenuGroup); // Load menu data based on selected menu group

  // const menuData = useMemo(() => SideMenuData(t, selectedMenuGroup), [t, selectedMenuGroup]); // Memoize menu data based on selected menu group


  useEffect(() => {
    // Handle updating selectedMenuGroup when menu groups change
    retrieveMenuData(); // Reset selected menu group to 'dashboard' on component mount or when menu groups change
  }, [selectedMenuGroup]);

  const retrieveMenuData = () => {
    var returnData = (menuList?.menus ?? []).filter(item => item.menu_groups && item.menu_groups.includes(selectedMenuGroup));

    // SideMenuData(theme, tenant, t, selectedMenuGroup);
    setMenuData(returnData);
  };

  // const history = useHistory();
  const navigate = useNavigate();

  const handleMenuItemClick = (path, code) => {
    console.log("path?? ", path)
    if (path) {
      // history.push(path);
      navigate(path);
    }
    if (code) {
      setSelectedPath(code);
    }
  };

  const handleSignIn = () => {
    if (findFeature(featuresEnum.CUSTOMER_PORTAL))
      navigateToAuth({ isAdmin: false });
    else {
      //show a message to show that this feature is not available
      notification.info({ message: "Sign In feature not available." });
    }
  };

  const handleRegister = () => {
    if (findFeature(featuresEnum.CUSTOMER_PORTAL)) navigate("/segment");
    // if(findFeature(featuresEnum.ADMIN_PORTAL))
    else {
      //navigate("/authentication/admin/register");
      //show a message to show that this feature is not available
      notification.info({ message: "Registration feature not available." });
    }
  };

  const handleSignOut = () => {
    dispatch(logoutUser());
    sessionData?.userClassification ===
      SelfUserClassificationEnum.BACKOFFICE_ADMINISTRATORS.value
      ? navigateToAuth({ isAdmin: true })
      : navigateToAuth({ isAdmin: false });
  };


  const handleMouseEnter = (menuKey) => {
    setIsHovered(true); // Set hover state to true
    console.log("menuKey?? ", menuKey)
    setOpenKeys([menuKey]);
  };

  const toggleMenuClick = (menuKey) => {
    console.log("menuKey?? ", menuKey, openKeys);
    if (isHovered) {
      setIsHovered(false); // Set hover state to false
      setOpenKeys([]);
    } else {
      setIsHovered(true); // Set hover state to true
      setOpenKeys([menuKey]);
    }

  };
  const addFeatureMenuItem = (featureKeys, item, permissionKey) => {
    // If featureKeys is an array, check all features
    const checkFeatures = () => {
      if (Array.isArray(featureKeys)) {
        return featureKeys.every((key) => findFeature(key));
      }
      return findFeature(featureKeys);
    };

    const shouldRender = permissionKey
      ? checkFeatures() && findPermission(permissionKey)
      : checkFeatures();

    return shouldRender ? [item] : [];
  };


  const handleMenuGroupSelect = (group) => {
    console.log('group', group);
    setSelectedMenuGroup(group);
  };


  const profileName = `${sessionData?.displayName}` || "";

  if (isFetchingMenuCommandChains) return <Spin />;
  return (
    <>

      <div style={{ overflowY: 'auto', height: 'calc(100vh)', minWidth: 40 }}>

        <Row style={{
          width: '100%',
          height: '100%',
          border: 'none',
          borderRadius: 0,
          backgroundColor: '#f0f2f5',
          // background: 'transparent',
          boxShadow: 'none',

        }}>
          <Col span={collapsed ? 24 : 5} style={{ backgroundColor: '#E5E7E9FF' }}>
            {collapsed && (<div className="custom-trigger" style={{
              backgroundColor: '#f0f2f5',
              marginBottom: 5,
              marginTop: 5,
              textAlign: 'right', paddingBottom: 3, marginLeft: 0,
              paddingTop: 5, paddingRight: 16
            }} >
              <Button
                type="text"
                shape="circle"
                onClick={toggleCollapsed}
                style={{
                  width: 32,
                  height: 32,
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                }}
                icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
                className="trigger-button"
              />
            </div>
            )}
            <div className="menu-group-icons">

              {(menuList?.modules ?? []).map((group) => {
                if (group.code.includes("divider")) return <></>;
                const IconComponent = Icons[group.icon];
                const isSelected = selectedMenuGroup === group.code;

                return (
                  <Tooltip key={group.code} title={t(group.name)} placement="right">
                    <Button
                      icon={
                        <IconComponent
                          style={{
                            color: isSelected ? tenant.theme.colorPrimary : 'inherit'
                          }}
                        />
                      }
                      onClick={() => handleMenuGroupSelect(group.code, group.path)}
                      style={{
                        width: '100%',
                        border: 'none',
                        fontSize: '14px',
                        borderRadius: 0,
                        borderRight: isSelected ? `2px solid ${tenant.theme.colorPrimary}` : 'none',
                        background: isSelected ? `${tenant.theme.colorPrimary}10` : 'transparent',
                        boxShadow: 'none',
                        padding: '25px 0',
                      }}
                    />
                  </Tooltip>
                );
              })}

            </div>

          </Col>
          {!collapsed && (
            <Col span={19} style={{ backgroundColor: '#EFF1F3FF' }}>
              <div className="custom-trigger" style={{
                backgroundColor: '#f0f2f5',
                textAlign: 'right', paddingBottom: 3, marginLeft: 0,
                paddingTop: 5, paddingRight: 16
              }} >
                <Button
                  type="text"
                  shape="circle"
                  onClick={toggleCollapsed}
                  style={{
                    width: 32,
                    height: 32,
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                  }}
                  icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
                  className="trigger-button"
                />
              </div>


              <div
                className={`${theme === "dark" ? "text-white bg-[#1d1d1d]" : "bg-[#f5f5f5]"
                  } flex items-center justify-start px-1 py-3 pr-3 rounded-lg mb-3 mx-0 gap-3 `}
              >
                <div
                  className="flex items-center justify-center text-lg text-white rounded-full select-none size-11 min-w-11"
                  style={{ backgroundColor: tenant.theme.colorPrimary }}
                >
                  {initials || "PN"}
                </div>
                <div className="flex-1 h-12 text-base">
                  <p>
                    <span className="block text-sm font-medium capitalize">
                      {profileName}
                    </span>

                    <span
                      className={`${theme === "dark" ? "text-[#8c8c8c]" : "text-[#595959]"
                        } text-sm block`}
                    >
                      {sessionData?.userClassificationDescription}
                    </span>
                  </p>
                </div>

                <ProfileDropdown />
              </div>


              {selectedMenuGroup && (
                <Menu
                  // theme="light"
                  style={{ backgroundColor: `${tenant.theme.colorPrimary}10`, }} ///fontSize: openKeys ? 40 : 30, fontWeight: openKeys ? "bold" : "normal"

                  mode="inline"
                >
                  <Menu.Item
                    key={"subItem.label"}
                    // icon={items.find((key) => key.key == selectedMenuGroup).icon}
                    icon={
                      (() => {
                        const iconName = (menuList?.modules ?? []).find((key) => key.code === selectedMenuGroup)?.icon;
                        const IconComponent = Icons[iconName];
                        return IconComponent ? <IconComponent /> : null;
                      })()
                    }
                    style={{
                      borderRight: 'none',
                      // border: 'none',
                      borderRadius: 0,
                      background: 'transparent',
                      boxShadow: 'none',
                      // padding: '20px 0',
                      // Add other styles as needed

                    }} >


                    <div className='block text-sm font-bold capitalize  '>
                      {t((menuList?.modules ?? []).find((key) => key.code == selectedMenuGroup)?.name)}
                    </div>


                  </Menu.Item>
                </Menu>
              )}

              <Menu
                // theme="light"
                style={{ backgroundColor: '#f5f7fa', }} ///fontSize: openKeys ? 40 : 30, fontWeight: openKeys ? "bold" : "normal"
                className='mt-4'
                defaultSelectedKeys={['1']}
                mode="inline"
                // onTitleClick={() => toggleMenuClick(item.label)}
                // onMouseLeave={handleMouseLeave}
                openKeys={openKeys}
                onOpenChange={(keys) => setOpenKeys(keys)}
              >
                {menuData.map((item) =>
                  item.submenus ? (
                    <SubMenu
                      key={item.code}
                      icon={
                        (() => {
                          const IconComponent = Icons[item.icon];
                          return IconComponent ? <IconComponent /> : null;
                        })()}
                      style={{
                        backgroundColor: '#f5f7fa'
                      }}
                      onTitleClick={() => toggleMenuClick(item.code)} // Handle submenu click
                      // onMouseEnter={() => handleMouseEnter(item.label)}
                      title={
                        // <Tooltip title={item.label} placement="right">
                        <div className={openKeys.includes(item.code) ? 'block text-sm font-medium capitalize  ' : "block text-sm font-normal capitalize  "}>
                          {t(item.label)}
                        </div>
                        // </Tooltip>
                      }
                    >
                      {item.submenus.map((subItem) => (
                        <Menu.Item
                          key={subItem.code}
                          icon={
                            (() => {
                              const IconComponent = Icons[subItem.icon];
                              return IconComponent ? <IconComponent /> : null;
                            })()
                          }
                          onClick={() => handleMenuItemClick(subItem.path, subItem.code)}
                          style={{
                            borderRight: selectedPath === subItem.code ? `4px solid ${tenant.theme.colorPrimary}` : 'none',
                            borderRadius: 0,
                            background: selectedPath === subItem.code ? `${tenant.theme.colorPrimary}10` : 'transparent',
                            boxShadow: 'none',
                            paddingRight: 0, // << This removes right padding
                            marginRight: 0,  // << This ensures it aligns flush
                          }}
                        >
                          {t(subItem.label)}
                        </Menu.Item>

                      ))}
                    </SubMenu>
                  ) : (
                    <Menu.Item
                      key={t(item.code)}
                      icon={
                        (() => {
                          const IconComponent = Icons[item.icon];
                          return IconComponent ? <IconComponent /> : null;
                        })()
                        // 
                      }
                      onClick={() => handleMenuItemClick(item.path)}
                      title={item.label}
                    >
                      <Tooltip title={item.label} placement="right">
                        {item.label}
                      </Tooltip>
                    </Menu.Item>
                  )
                )}
              </Menu>
            </Col>
          )}
        </Row>
      </div >
    </>
  );
};

export default MainLayout;